import { render, staticRenderFns } from "./VenueSync.vue?vue&type=template&id=6d6fca96"
import script from "./VenueSync.vue?vue&type=script&lang=ts"
export * from "./VenueSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports